import React from "react";

const StakeholdersAndVisibilityVideo = ({ subsection, saveProgress }) => {
  const about = (
    <div className="space-y-5 pt-2 pb-6 text-body leading-7 text-[#484848]">
      <p>
This lesson breaks the belief that your boss alone controls your growth. It introduces stakeholders as the wider web of people whose decisions, opinions, and casual narratives shape promotions, projects, and opportunities. It maps the main types, decision makers, influencers, gatekeepers, amplifiers, and the people affected by your work. The core idea is simple: if only your boss knows your impact, you stay invisible when group decisions happen.
      </p>
    </div>
  );

  const transcript = (
    <div className="pt-2 pb-6">
      <p className="text-muted italic">Transcript will be available soon.</p>
    </div>
  );

  // const relatedLinks = (
  //   <div className="pt-2 pb-6">
  //     <ul className="list-disc list-inside text-body space-y-2">
  //       <li>
  //         <button type="button" className="text-link">
  //           Download Slides
  //         </button>
  //       </li>
  //       <li>
  //         <button type="button" className="text-link">
  //           Reference Reading: Career Transitions Report 2025
  //         </button>
  //       </li>
  //     </ul>
  //   </div>
  // );

  // ✅ CORRECT: Return plain object (no JSX wrapper)
  return { 
    about, 
    transcript, 
    // relatedLinks,
    // Include the question so VideoContainer can show it
    question: "Did you think about stakeholders before?"
  };
};

export default StakeholdersAndVisibilityVideo;